import type { ResourceLinkType } from "../types";

/**
 * This function infers the resource link type from a URL's hostname, so callers don't have
 * to ask the user to classify a link that's already identifiable from where it points.
 * @param url
 * @returns
 */
export function inferResourceLinkType(url: string): ResourceLinkType | null {
	try {
		const { hostname } = new URL(url);
		if (/(^|\.)trimble\.com$/i.test(hostname)) return "trimble";
		return null;
	} catch {
		return null;
	}
}
